module.exports = __webpack_public_path__ + "img/president_message_en.d91091a.webp";